import { bl_sfa_sales_lead_label_hdr_RowClass} from "../../dbschema/bl_sfa_sales_lead_label_hdr.model";
import { BaseContainerModel } from "../base-container.model";

export class SfaSalesLeadLabelHdrContainerModel extends BaseContainerModel {
	bl_sfa_sales_lead_label_hdr: bl_sfa_sales_lead_label_hdr_RowClass =
		new bl_sfa_sales_lead_label_hdr_RowClass();
}